export enum ManagementRoute {
  SETTINGS = 'settings',
  BUDGET_GL_CATEGORIES = 'budget-gl-categories',
  SURVEYS = 'surveys',
  USERS = 'users',
  NOT_RESIDENTS = 'list',
  RESIDENTS = 'residents',
  SUMMARY = 'summary',
  ROLES = 'roles-management',
  NEW = 'new',
  EDIT = 'edit',
  RENEWAL_STRATEGY = 'renewal-strategy',
  KPI = 'kpi',
  PORTFOLIO = 'portfolio',
  COLLECTION = 'collection',
  INSPECT = 'inspect',
  PMS_MAPPING = 'pms-mapping',
  VENDOR = 'vendor',
  SYSTEM = 'system',
  TURNOVER_CONFIGURATION = 'turnover-configuration',
  USER = 'user',
  DYNAMIC = 'dynamic',
  BULK = 'bulk',
  REPEATING = 'repeating',
  IN_REVIEW = 'in-review',
  RESIDENT = 'resident',
  TEMPLATES = 'templates',
  SPACE_TEMPLATE = 'space-template',
  SERVICE = 'service',
  BRANDING = 'branding',
  NOTIFICATIONS = 'notifications',
  PROPERTY_MODEL = 'property-model',
}
